import { DietIdEnum } from '@front-activerse/common-components';
import type { goalSettings, stepConfigItem } from './types';

const stepsSchemaEn: stepConfigItem[] = [
  {
    id: 'dietType',
    slug: 'diet-type',
    fork: {
      chooseChild: (state: goalSettings) =>
        state.dietType === DietIdEnum.DIET_ID_GLP1 ||
        state.dietType === DietIdEnum.DIET_ID_GLP1_CLASSIC ||
        state.dietType === DietIdEnum.DIET_ID_GLP1_FRIENDLY
          ? 'dietLevel'
          : 'summary',
      children: {
        dietLevel: [
          { id: 'dietLevel', slug: 'diet-level' },
          { id: 'summary', slug: 'summary' },
        ],
        summary: [{ id: 'summary', slug: 'summary' }],
      },
    },
  },
];

export default stepsSchemaEn;
